export const menuItems = [
  {
    path: "/",
    text: "home",
  },
  {
    path: "/services",
    text: "services",
  },
  {
    path: "/blogs",
    text: "blogs",
  },
  {
    path: "/contact",
    text: "contact",
  },
  {
    path: "/ja",
    text: "Japanese",
  },
]
